import { createContext, useContext, PropsWithChildren, useState } from 'react';

interface UIContextValue {
  sidebarOpen: boolean;
  setSidebarOpen: (state: boolean) => void;
  fullscreenMode: boolean;
  setFullscreenMode: (mode: boolean) => void;
  submenuOpen: boolean;
  setSubmenuOpen: (state: boolean) => void;
}

const UIContext = createContext<UIContextValue>({
  sidebarOpen: true,
  setSidebarOpen: () => {},
  fullscreenMode: false,
  setFullscreenMode: () => {},
  submenuOpen: false,
  setSubmenuOpen: () => {},
});

export const UIContextProvider = ({ children }: PropsWithChildren) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [fullscreenMode, setFullscreenMode] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState(false);

  return (
    <UIContext.Provider
      value={{
        sidebarOpen,
        setSidebarOpen,
        fullscreenMode,
        setFullscreenMode,
        submenuOpen,
        setSubmenuOpen,
      }}
    >
      {children}
    </UIContext.Provider>
  );
};

export const useUIContext = () => useContext(UIContext);
